module.exports = {
        srcSet: __webpack_public_path__ + "assets/images/image-05026f985cb1a8a4.png"+" 972w",
        images: [{path: __webpack_public_path__ + "assets/images/image-05026f985cb1a8a4.png",width: 972,height: 396}],
        src: __webpack_public_path__ + "assets/images/image-05026f985cb1a8a4.png",
        toString: function(){return __webpack_public_path__ + "assets/images/image-05026f985cb1a8a4.png"},
        
        width: 972,
        height: 396
      }